import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
  Button,
} from "@mui/material";
import { ReactComponent as GenerateButton } from "../../images/generateButton.svg";
import { exportToCSV } from "../download/qeBotExportToCSV";
import { exportToXLS } from "../download/qeBotExportToExcel";
import { exportToPDF } from "../download/qeBotExportToPdf";
import wordGenerator from "../download/qeBotWordGenerator";
import { exportToDastXLSWithDropdowns } from "../download/DASTRun1Excel";
import { exportToDastXLSRun2 } from "../download/DASTRun2Excel";
import { exportToSastXLSRun1 } from "../download/SASTRun1Excel";
import { exportToSastXLSRun2 } from "../download/SASTRun2Excel";

function CommonDownload({
  open,
  onClose,
  serviceResponse,
  serviceName,
  wordData,
  documents,
  onDownloadSuccess, // Optional callback
  onCancel,
  runType, // Optional callback
}) {
  const getDefaultFileFormat = () => {
    if (documents.includes("docx")) return ".docx";
    if (documents.includes("xls")) return ".xls";
    if (documents.includes("xlsx")) return ".xlsx";
    return documents[0] || "";
  };

  const [fileFormat, setFileFormat] = useState(getDefaultFileFormat());

  // Update file format when documents change
  useEffect(() => {
    setFileFormat(getDefaultFileFormat());
  }, [documents]);

  // Update the handleDownload function
  const handleDownload = () => {
    switch (fileFormat) {
      case ".csv":
        exportToCSV(serviceResponse, serviceName);
        break;
      case ".xls":
        exportToXLS(serviceResponse, serviceName);
        break;
      // In your CommonDownload component's handleDownload function:
      case ".xlsx":
        if (serviceName === "DAST Scan Report" && runType === "Run-1") {
          exportToDastXLSWithDropdowns(serviceResponse, serviceName);
        } else if (serviceName === "DAST Scan Report" && runType === "Run-2") {
          // 🔥 FIX: Pass the flattened data directly
          exportToDastXLSRun2(serviceResponse, serviceName);
        } else if (serviceName === "DAST Scan Report") {
          exportToDastXLSRun2(serviceResponse, serviceName);
        } else if (serviceName === "SAST Scan Report" && runType === "Run-1") {
          exportToSastXLSRun1(serviceResponse, serviceName, runType);
        } else if (serviceName === "SAST Scan Report" && runType === "Run-2") {
          exportToSastXLSRun2(serviceResponse, serviceName, runType);
        } else {
          exportToXLS(serviceResponse, serviceName);
        }
        break;

      case ".pdf":
        exportToPDF(serviceResponse, serviceName);
        break;
      case ".docx":
        wordGenerator(wordData, serviceName);
        break;
      default:
        console.warn("Unsupported file format selected");
    }
    onClose();
    if (onDownloadSuccess) onDownloadSuccess();
  };

  const handleCancel = () => {
    onClose(); // Close the dialog
    if (onCancel) onCancel(); // ✅ Notify cancel
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      PaperProps={{
        sx: {
          borderRadius: "8px",
          minWidth: "500px",
        },
      }}
    >
      <DialogTitle>Download As</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: 2 }}>
          <FormControl fullWidth>
            <InputLabel>Select file format</InputLabel>
            <Select
              value={fileFormat}
              onChange={(e) => setFileFormat(e.target.value)}
              label="Select file format"
            >
              {documents.includes("docx") && (
                <MenuItem value=".docx">.docx</MenuItem>
              )}
              {documents.includes("pdf") && (
                <MenuItem value=".pdf">.pdf</MenuItem>
              )}
              {documents.includes("xls") && (
                <MenuItem value=".xls">.xls</MenuItem>
              )}
              {documents.includes("xlsx") && (
                <MenuItem value=".xlsx">.xlsx</MenuItem>
              )}
              {documents.includes("csv") && (
                <MenuItem value=".csv">.csv</MenuItem>
              )}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "5px 24px 16px 24px",
          gap: "5px",
        }}
      >
        <Button
          onClick={handleCancel}
          color="primary"
          sx={{
            textTransform: "capitalize",
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDownload}
          variant="contained"
          sx={{
            color: "white",
            backgroundColor: "#49A3FF",
            gap: "5px",
            textTransform: "capitalize",
            "&:hover": {
              backgroundColor: "#3691E6",
            },
          }}
        >
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CommonDownload;
